import api from './api';

export const productHistoryService = {
  async getProductHistory(productId, filters = {}) {
    try {
      const params = {
        page: filters.page || 1,
        per_page: filters.per_page || 30,
        ...(filters.search && { search: filters.search }),
        ...(filters.date_from && { date_from: filters.date_from }),
        ...(filters.date_to && { date_to: filters.date_to }),
        ...(filters.operation_type && { operation_type: filters.operation_type }),
        ...(filters.location_id && { location_id: filters.location_id }),
        ...(filters.warehouse_id && { warehouse_id: filters.warehouse_id })
      };

      const response = await api.get(`/products/${productId}/history`, { params });

      return response.data;
    } catch (error) {
      console.error('Błąd pobierania historii produktu:', error);
      throw error;
    }
  }
};
